// Formats the stored full support-ticket reference (TP-YYYYMMDD-XXXXX) into the
// short display form (TP-XXXXX) used on user/admin-facing surfaces. The stored
// id is never changed — this only derives a display value, so lookups and
// persistence keep using the full id. Ids that do not match the expected
// format are returned unchanged.
export function formatShortTicketRef(ticketId: string | null | undefined): string {
  const raw = String(ticketId || '').trim();
  if (!raw) return '';
  const parts = raw.split('-');
  if (parts.length >= 3 && parts[0] && parts[parts.length - 1]) {
    return `${parts[0]}-${parts[parts.length - 1]}`;
  }
  return raw;
}
